var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Youtube"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M118.9,13.3C117.5,8,113.4,4,108.2,2.5C98.7,0,60.7,0,60.7,0s-38,0-47.5,2.5C8,4,4,8,2.5,13.3\n\t\t\tC0,22.8,0,42.5,0,42.5s0,19.8,2.5,29.2C4,77,8,81.1,13.3,82.5C22.8,85,60.7,85,60.7,85s38,0,47.5-2.5c5.2-1.4,9.3-5.5,10.7-10.7\n\t\t\tc2.5-9.5,2.5-29.2,2.5-29.2S121.5,22.8,118.9,13.3z M48.6,60.7V24.3l31.6,18.2L48.6,60.7z"})))]);
}

SocialYoutube.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 121.5 85","style":{"enableBackground":"new 0 0 121.5 85"},"xmlSpace":"preserve"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
